<template>
  <div class="popin-vue">
    <div class="popin-background"></div>
    <div class="popin-wrapper" role="dialog" aria-modal="true">
      <button class="popin-close" type="button" data-dismiss="dialog">
        <i class="ico ico-cross"></i>
        <span class="sr-only">{{ Translator('front.alert.close') }}</span>
      </button>
      <div class="popin-content">
        <p class="alert-content" v-html="Translator('front.cart.free_alert.content')"></p>
        <p>
          <button class="alert-button" @click="onSelect">{{ Translator('front.cart.free_alert.button_accept') }}</button>
        </p>
        <p>
          <button class="alert-link" @click="onSkip">{{ Translator('front.cart.free_alert.button_skip') }}</button>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import AppControlService from '@/services/AppControl';
import ModalService from '@/services/Modal';
import OrdersService from '@/services/Orders';

export default {
  name: 'cart-confirm-free',
  data () {
    return {

    }
  },
  created() {},

  beforeDestroy() {},

  mounted() {},

  methods: {
    onSelect() {
      OrdersService.alertFree = true;
      ModalService.close();
    },

    onSkip() {
      ModalService.close();
      AppControlService.validStep();
    },

    Routing(key, datas = null) {
      return window.Routing.generate(key, datas);
    },

    Translator(key, datas = null) {
      return window.Translator.trans(key, datas);
    },
  }
};
</script>
<style scoped lang="scss">
  .viewer-element .popin-vue {
    .alert-content {
      @include upper;
      margin-bottom: rem(20);
      line-height: 2em;
    }
    .alert-button {
      @include cta;
      margin-bottom: rem(10);
    }
    .alert-link {
      @include link;
    }
    .popin-wrapper {
      max-width: rem(500);
    }
    .popin-content {
      text-align: center;
      padding: rem(40) rem(30);
    }
  }
</style>